// =============================================================================
// src/views/comparador/comparador-markup.ts — Marcacao FIEL da Tela 03 (Comparador).
//
// Proveniencia: unified.html linhas 573-666 (#section-comparador). String HTML
//   reproduzida 1:1 — mesmas tags/classes/ids/atributos/texto/SVG inline, incluindo
//   os onclick="sendPrompt(...)" que seguem funcionando via window.sendPrompt.
//   NAO alterar markup: o constraint do usuario e paridade visual exata.
//
// SRP: este arquivo so produz a string da area; binding/estado ficam em index.ts
//   e a logica dos 3 modos em comparador-modes.ts (extraido para manter <500 linhas).
// =============================================================================

import { buildProvenanceFooterMarkup } from '../../data/data-provenance';
/** Cartao de grupo politico (A/B/C) com cor, nome, tendencia, chips e share. */
function renderComparadorGroupCards(): string {
  return `        <div class="u-panel">
          <!-- Group cards -->
          <div style="display:flex;flex-direction:column;gap:6px">
            <div class="u-group-card" data-group="A">
              <div class="u-gc-header">
                <div class="u-gc-color" style="background:#534AB7"></div>
                <div class="u-gc-name">Base Lula AM</div>
                <div class="u-gc-trend up"><i class="ti ti-trending-up" aria-hidden="true"></i> 4pp</div>
              </div>
              <div class="u-gc-chips">
                <span class="u-gc-chip">PT</span><span class="u-gc-chip">PSB</span><span class="u-gc-chip">SOLIDARIEDADE</span><span class="u-gc-chip add">+ partido</span>
              </div>
              <div class="u-gc-stats"><span class="pct">32%</span><span class="meta">do eleitorado</span></div>
            </div>

            <div class="u-group-card" data-group="B">
              <div class="u-gc-header">
                <div class="u-gc-color" style="background:#BA7517"></div>
                <div class="u-gc-name">Direita PL+UB</div>
                <div class="u-gc-trend up"><i class="ti ti-trending-up" aria-hidden="true"></i> 13pp</div>
              </div>
              <div class="u-gc-chips">
                <span class="u-gc-chip">PL</span><span class="u-gc-chip">UNIÃO</span><span class="u-gc-chip">REPUB</span><span class="u-gc-chip add">+ partido</span>
              </div>
              <div class="u-gc-stats"><span class="pct">41%</span><span class="meta">do eleitorado</span></div>
            </div>

            <div class="u-group-card" data-group="C">
              <div class="u-gc-header">
                <div class="u-gc-color" style="background:#1D9E75"></div>
                <div class="u-gc-name">Centrão</div>
                <div class="u-gc-trend down"><i class="ti ti-trending-down" aria-hidden="true"></i> 15pp</div>
              </div>
              <div class="u-gc-chips">
                <span class="u-gc-chip">MDB</span><span class="u-gc-chip">PSD</span><span class="u-gc-chip">AVANTE</span><span class="u-gc-chip add">+ partido</span>
              </div>
              <div class="u-gc-stats"><span class="pct">27%</span><span class="meta">do eleitorado</span></div>
            </div>
          </div>

          <div style="display:flex;gap:8px">
            <button class="u-cta-btn secondary" style="flex:1" onclick="sendPrompt('Adicionar 4º grupo ao comparador')"><i class="ti ti-plus"></i> Adicionar 4º grupo</button>
            <button class="u-cta-btn" onclick="sendPrompt('Exportar relatório comparativo')"><i class="ti ti-file-analytics"></i> Exportar relatório</button>
          </div>`;
}

/** Grafico de evolucao 2014-2024 (SVG inline com 3 polylines + dots), verbatim. */
function renderComparadorEvolutionChart(): string {
  return `          <!-- Evolution chart -->
          <div>
            <div class="u-panel-section-label">Evolução 2014–2024</div>
            <svg viewBox="0 0 320 100" style="width:100%;height:100px;display:block">
              <defs>
                <linearGradient id="cg1" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#534AB7"/><stop offset="100%" stop-color="#534AB7" stop-opacity="0.6"/></linearGradient>
              </defs>
              <!-- Grid lines -->
              <line x1="0" y1="20" x2="320" y2="20" stroke="var(--color-border-tertiary)" stroke-width="0.5"/>
              <line x1="0" y1="50" x2="320" y2="50" stroke="var(--color-border-tertiary)" stroke-width="0.5"/>
              <line x1="0" y1="80" x2="320" y2="80" stroke="var(--color-border-tertiary)" stroke-width="0.5"/>
              <!-- Labels -->
              <text x="5" y="85" fill="var(--color-text-tertiary)" font-size="7">2014</text>
              <text x="57" y="85" fill="var(--color-text-tertiary)" font-size="7">2016</text>
              <text x="109" y="85" fill="var(--color-text-tertiary)" font-size="7">2018</text>
              <text x="162" y="85" fill="var(--color-text-tertiary)" font-size="7">2020</text>
              <text x="215" y="85" fill="var(--color-text-tertiary)" font-size="7">2022</text>
              <text x="268" y="85" fill="var(--color-text-tertiary)" font-size="7">2024</text>
              <!-- Group A: Base Lula -->
              <polyline points="10,55 62,52 114,58 166,50 218,48 270,42" fill="none" stroke="#534AB7" stroke-width="1.8" stroke-linejoin="round"/>
              <!-- Group B: Direita -->
              <polyline points="10,65 62,58 114,52 166,45 218,38 270,30" fill="none" stroke="#BA7517" stroke-width="1.8" stroke-linejoin="round"/>
              <!-- Group C: Centrão -->
              <polyline points="10,35 62,40 114,42 166,48 218,52 270,60" fill="none" stroke="#1D9E75" stroke-width="1.8" stroke-linejoin="round"/>
              <!-- Dots at end -->
              <circle cx="270" cy="42" r="3.5" fill="#534AB7"/>
              <circle cx="270" cy="30" r="3.5" fill="#BA7517"/>
              <circle cx="270" cy="60" r="3.5" fill="#1D9E75"/>
            </svg>
          </div>
        </div>`;
}

/**
 * Marcacao completa da Tela 03 (<section id="section-comparador">). Concatena
 * header + mode-bar + cards + grafico na ORDEM exata de unified.html (573-666).
 * @returns string HTML literal, paridade total com o original.
 */
export function renderComparadorSection(): string {
  return `    <section class="u-section" id="section-comparador" data-section="comparador">
      <div class="u-section-header">
        <div class="u-section-title">Comparador de Grupos Políticos</div>
        <div class="u-section-subtitle">Análise comparativa entre coligações e tendências históricas</div>
      </div>
      <div class="u-section-body">
        <!-- Mode bar -->
        <div class="u-mode-bar">
          <div class="u-mode-tabs">
            <button class="u-comp-mode-tab active" data-mode="diff"><i class="ti ti-stack-2" style="font-size:12px"></i> Diferença</button>
            <button class="u-comp-mode-tab" data-mode="split"><i class="ti ti-layout-columns" style="font-size:12px"></i> Lado a lado</button>
            <button class="u-comp-mode-tab" data-mode="overlay"><i class="ti ti-circles" style="font-size:12px"></i> Sobreposição</button>
          </div>
          <div class="right"><i class="ti ti-info-circle"></i> Cenário: Manaus 2024 vs histórico</div>
        </div>

${renderComparadorGroupCards()}

${renderComparadorEvolutionChart()}
      </div>
      ${buildProvenanceFooterMarkup('comparador')}
    </section>`;
}
